import styled from 'styled-components'
import { Flex } from 'vvs-uikit'
import Row from 'components/Layout/Row'

export const Header = styled.div`
  background-image: url(/images/vvsGotchi/bg_grass.png);
  background-size: cover;
  padding: 16px 15px 24px;
`

export const ListWrapper = styled(Flex)`
  flex: 1;
  width: 100%;
  padding-top: 16px;
  flex-direction: column;
`

export const ArrowArea = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  padding: 0 20px;
  :hover {
    cursor: pointer;
  }
`

export const StyledRow = styled(Row)`
  width: auto;
  padding: 16px 0;
  margin: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  &:last-child {
    border-bottom: 0;
  }
`

export const InfoGroup = styled(Flex)`
  flex-direction: column;
  flex: 3;
`
